import Vue from "vue";
import { tenantConfig, tenantFlag } from "@/services/tenantConfigService";
import { isGuidedTourDisabled } from "@/services/onboardingRollout";
import { TourContext } from "@/tour/types";

/**
 * Gathers everything a module's gates can ask about from the running application.
 *
 * Built in one place because two callers need the same answers: DashboardLayout, which hands it to
 * the service, and the tour hub, which uses it to decide which modules to list. Two builders would
 * eventually disagree, and the symptom -- the hub offering a module the service then skips every
 * step of -- looks like a broken tour rather than a mismatch.
 *
 * `canNavigateTo` and `hasPermission` are the application's own, so the tour can never offer a page
 * the router guard would bounce the user out of.
 */
export function buildTourContext(vm: Vue): TourContext {
    return {
        canNavigateTo: (location) => vm.$canNavigateTo?.(location) === true,
        // Case-insensitive, matching how the router guard and the sidebar compare codes.
        hasPermission: (code) => (vm.$permissions ?? [])
            .some((permission) => permission.permissionCodeName?.toLowerCase() === code.toLowerCase()),
        sandboxMode: tenantFlag("sandboxMode"),
        tourDisabled: isGuidedTourDisabled(),
        tenantConfig: tenantConfig(),
        pageNames: vm.$pageNames ?? {},
    };
}
